import React, { useEffect, useRef, useState } from 'react'
import './admin.styles.scss';
import HeadBarAdmin from '@/components/ADMIN/head-bar-admin/head-bar-admin.component';
import SidebarAdminContainer from '@/components/ADMIN/sidebar-admin/sidebar-admin-container.component';
import { Navigate, Route, Routes, useNavigate } from 'react-router-dom';
import UserListContainer from '@/components/ADMIN/manage-users/user-list-container.component';
import { useSelector } from 'react-redux';
import UserView from '@/components/ADMIN/manage-users/user-view.component';
import AdminActivityLogs from '@/components/ADMIN/activity-logs/activity-logs.component';
import AdminBugReports from '@/components/ADMIN/bug-reports/bug-reports.component';
import AdminFunctions from '@/components/ADMIN/functions/functions.components';
import { UseCloudAdminFn } from '@/utils/firebase.utils';
import Loader from '@/components/loader/loader.comp';
import AdminManageGamesLanding from '@/components/ADMIN/manage-games/admin-manage-games-landing.component';
import OrgListContainer from '@/components/ADMIN/manage-orgs/org-list-container.component';
import AdminContentLanding from '@/components/ADMIN/content/admin-content-landing.component';
import { changeDocumentTitle } from '@/utils/useDocumentTitle';
import { getGameOwnersFromRtDb } from '@/utils/getAdminData';
import AdminAnnouncements from '@/components/ADMIN/announcements/admin-announcements.component';
import ResourceManager from '@/components/ADMIN/resource-manager/resource-manager.component';

const AdminPage = () => {

  const userProfile = useSelector(state => state.userData.userProfile);
  const [admin, setAdmin] = useState(false);
  const [owners, setOwners] = useState(null);
  const ownersRef = useRef();
  const ownersListenerRef = useRef();
  const navigate = useNavigate();

  useEffect(() => {
    const hue = Math.floor(Math.random() * 360);
    const hslLuminance = (h, s, l) => {
      s /= 100; l /= 100;
      const a = s * Math.min(l, 1 - l);
      const f = n => { const k = (n + h / 30) % 12; return l - a * Math.max(Math.min(k - 3, 9 - k, 1), -1); };
      return [f(0), f(8), f(4)].reduce((sum, c, i) => {
        const lin = c <= 0.04045 ? c / 12.92 : ((c + 0.055) / 1.055) ** 2.4;
        return sum + lin * [0.2126, 0.7152, 0.0722][i];
      }, 0);
    };
    let lightness = 45;
    while (lightness > 5 && (1.05 / (hslLuminance(hue, 45, lightness) + 0.05)) < 4.5) {
      lightness -= 1;
    }
    const randomColor = `hsl(${hue}, 45%, ${lightness}%)`;
    const randomColorTrans = `hsla(${hue}, 45%, ${lightness}%, 0.65)`;
    var r = document.querySelector(':root');
    r.style.setProperty('--primary', randomColor);
    r.style.setProperty('--primary-trans', randomColorTrans);

  // move checkForAccess, changeDocumentTitle, and getGameOwners calls here
      async function checkForAccess() {
        const adminTF = await UseCloudAdminFn(
          'checkAdmin',
          { 'appId': userProfile.appId }
        )
        setAdmin(adminTF.success)
        if (!adminTF.success) {
          navigate('/home');
          return;
        }
      }
      checkForAccess();
      changeDocumentTitle('Gamably Admin');
      getGameOwners();

    return () => {
      if (ownersListenerRef.current) ownersListenerRef.current();
    }
  }, [])

  function getGameOwners() {
    console.log('getting game owners');
    getGameOwnersFromRtDb({
      'callback': callback,
      'handleListener': handleListener
    })
    function callback(data) {
      console.log(data);
      ownersRef.current = {
        ...ownersRef.current,
        ...{ [data.appId]: data }
      }
      setOwners(ownersRef.current);
    }
    function handleListener(unsub) {
      ownersListenerRef.current = unsub;
    }
  }


  return (
    <>
      {(admin)
        ?
        <div className='admin-page'>
          <HeadBarAdmin />
          <div className='admin-layout'>
            <SidebarAdminContainer />
            <div className='admin-right-content'>
              <Routes>
                <Route path='' element={'Admin content'}></Route>
                <Route path='games/*' element={
                  <AdminManageGamesLanding
                    owners={owners} />
                }></Route>
                <Route path='orgs/*' element={<OrgListContainer />}></Route>
                <Route path='content/*' element={
                  <AdminContentLanding
                    owners={owners} />
                }></Route>
                <Route path='users' element={
                  <UserListContainer
                    owners={owners} />
                }></Route>
                <Route path='users/:appId' element={<UserView />}></Route>
                <Route path='announcements/*' element={
                  <AdminAnnouncements />
                }></Route>
                {/* <Route path='templategames/*' element={<TemplateGamesContainer />}></Route> */}
                <Route path='logs' element={<AdminActivityLogs />}></Route>
                <Route path='bugs' element={<AdminBugReports />}></Route>
                <Route path='functions' element={<AdminFunctions />}></Route>
                <Route path='resources' element={<ResourceManager />}></Route>
                <Route path="*" element={<Navigate replace to="/404" />} />
              </Routes>
            </div>
          </div>
        </div>
        :
        <div className='admin-page'>
          <div className='loader-container'>
            <Loader />
          </div>
        </div>
      }
    </>
  )
}

export default AdminPage